<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  created () {
  	// let token = localStorage.getItem('access_token')
  	// let id = localStorage.getItem('client_id')
  	// let company = localStorage.getItem('company')
   //  let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

   //  if(user && user.id) {
   //    this.$store.commit('setUser', user);
   //    this.$store.commit("setAccessToken", user.token);
   //    this.$store.commit("setClientId", user.id);
   //    this.$store.commit("setCompany", user.company);
   //  }
  	// else if (token && id){
  	// 	this.$store.commit("setAccessToken", token);
			// this.$store.commit("setClientId", id);
			// this.$store.commit("setCompany", company);

   //    let params = {
   //      'token': token
   //    };
   //    this.$http.get(process.env.API_URL+'/user/'+id, {'params': params}).then(response => {
   //      response = response.data || response;
   //      this.$store.commit('setUser', JSON.stringify(response));
   //      localStorage.setItem('user', response);
   //    })
  	// }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue